import React, { useEffect, useState } from 'react';
import { Clock, Heart } from 'lucide-react';
const COUNTDOWN_KEY = 'countdown-timer';
const DEFAULT_TIME = 5 * 60 * 60; // 5 hours in seconds
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(() => {
    const saved = localStorage.getItem(COUNTDOWN_KEY);
    if (saved) {
      const parsed = parseInt(saved, 10);
      if (parsed > 0 && parsed <= DEFAULT_TIME) {
        return parsed;
      }
    }
    return DEFAULT_TIME;
  });
  useEffect(() => {
    // Save initial time if not already saved
    if (!localStorage.getItem(COUNTDOWN_KEY)) {
      localStorage.setItem(COUNTDOWN_KEY, DEFAULT_TIME.toString());
    }
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        const newTime = prev > 0 ? prev - 1 : 0;
        if (newTime % 5 === 0) {
          localStorage.setItem(COUNTDOWN_KEY, newTime.toString());
        }
        return newTime;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return {
      h,
      m,
      s
    };
  };
  const {
    h,
    m,
    s
  } = formatTime(timeLeft);
  return <div className="w-full max-w-2xl mx-auto bg-white/90 backdrop-blur-md rounded-[2rem] p-8 shadow-2xl border border-[#D4A5A5]/30 relative overflow-hidden group hover:scale-[1.02] transition-transform duration-500" data-id="element-277">
      {/* Background Effect */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#D4A5A5]/10 via-transparent to-[#D4A5A5]/10 pointer-events-none" data-id="element-278" />
      <div className="absolute -top-10 -right-10 w-32 h-32 bg-[#D4A5A5]/20 rounded-full blur-3xl animate-pulse" data-id="element-279" />
      <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-[#C9A86A]/20 rounded-full blur-3xl animate-pulse" style={{
      animationDelay: '1s'
    }} data-id="element-280" />

      <div className="relative z-10 flex flex-col items-center" data-id="element-281">
        <div className="flex items-center gap-3 mb-6 bg-[#D4A5A5]/10 px-6 py-2 rounded-full border border-[#D4A5A5]/20" data-id="element-282">
          <Clock className="w-5 h-5 text-[#D4A5A5] animate-pulse" data-id="element-283" />
          <span className="font-serif font-bold tracking-widest uppercase text-[#3A3A3A] text-sm md:text-base" data-id="element-284">
            ⏳ Oferta especial por tiempo limitado
          </span>
        </div>

        <div className="flex items-center justify-center gap-4 md:gap-8 text-center w-full" data-id="element-285">
          {/* Hours */}
          <div className="flex flex-col items-center" data-id="element-286">
            <div className="bg-gradient-to-br from-[#3A3A3A] to-[#2A2A2A] rounded-2xl p-4 md:p-6 shadow-lg min-w-[80px] md:min-w-[100px] border border-[#C9A86A]/30" data-id="element-287">
              <span className="text-4xl md:text-6xl font-serif font-bold text-[#FAF7F5] tabular-nums" data-id="element-288">
                {h.toString().padStart(2, '0')}
              </span>
            </div>
            <span className="text-xs md:text-sm font-bold text-[#C9A86A] mt-3 uppercase tracking-widest" data-id="element-289">
              Horas
            </span>
          </div>

          <span className="text-4xl md:text-6xl font-serif text-[#D4A5A5] mb-8 animate-pulse" data-id="element-290">
            :
          </span>

          {/* Minutes */}
          <div className="flex flex-col items-center" data-id="element-291">
            <div className="bg-gradient-to-br from-[#3A3A3A] to-[#2A2A2A] rounded-2xl p-4 md:p-6 shadow-lg min-w-[80px] md:min-w-[100px] border border-[#C9A86A]/30" data-id="element-292">
              <span className="text-4xl md:text-6xl font-serif font-bold text-[#FAF7F5] tabular-nums" data-id="element-293">
                {m.toString().padStart(2, '0')}
              </span>
            </div>
            <span className="text-xs md:text-sm font-bold text-[#C9A86A] mt-3 uppercase tracking-widest" data-id="element-294">
              Minutos
            </span>
          </div>

          <span className="text-4xl md:text-6xl font-serif text-[#D4A5A5] mb-8 animate-pulse" data-id="element-295">
            :
          </span>

          {/* Seconds */}
          <div className="flex flex-col items-center" data-id="element-296">
            <div className="bg-gradient-to-br from-[#3A3A3A] to-[#2A2A2A] rounded-2xl p-4 md:p-6 shadow-lg min-w-[80px] md:min-w-[100px] border border-[#C9A86A]/30" data-id="element-297">
              <span className="text-4xl md:text-6xl font-serif font-bold text-[#FAF7F5] tabular-nums" data-id="element-298">
                {s.toString().padStart(2, '0')}
              </span>
            </div>
            <span className="text-xs md:text-sm font-bold text-[#C9A86A] mt-3 uppercase tracking-widest" data-id="element-299">
              Segundos
            </span>
          </div>
        </div>
      </div>
    </div>;
}